import { AnyAction } from 'redux'
import { all, call, put, select, takeEvery } from 'redux-saga/effects'
import { AppState } from 'redux/config/store'
import { AutoEnrollRule } from './autoEnrollTypes'
import { autoEnrollActions, isTempId } from './autoEnrollSlice'
import AutoEnrollService from './autoEnrollService'

export function* getAutoEnrollRulesSaga(_action: AnyAction) {
  try {
    const res = yield call(AutoEnrollService.getAutoEnrollmentRules)
    yield put(autoEnrollActions.getAutoEnrollRulesSuccess(res.data ?? []))
  } catch {
    yield put(autoEnrollActions.getAutoEnrollRulesFailed())
  }
}

export function* saveAutoEnrollRulesSaga(_action: AnyAction) {
  yield put(autoEnrollActions.setSaveLoading(true))
  try {
    const { rules, savedRuleIds } = yield select((s: AppState) => ({
      rules: s.autoEnroll.rules,
      savedRuleIds: s.autoEnroll.savedRuleIds,
    }))

    const newRules = rules.filter((r: AutoEnrollRule) => isTempId(r.id))
    const persistedRules = rules.filter((r: AutoEnrollRule) => !isTempId(r.id))
    const deletedIds = savedRuleIds.filter(
      (id: string) => !rules.some((r: AutoEnrollRule) => r.id === id)
    )

    for (const rule of newRules) {
      yield call(AutoEnrollService.createAutoEnrollmentRule, rule)
    }

    for (const rule of persistedRules) {
      yield call(AutoEnrollService.modifyAutoEnrollmentRule, rule.id, rule)
    }

    for (const id of deletedIds) {
      yield call(AutoEnrollService.deleteAutoEnrollmentRule, id)
    }

    const res = yield call(AutoEnrollService.getAutoEnrollmentRules)
    yield put(autoEnrollActions.getAutoEnrollRulesSuccess(res.data ?? []))
    yield put(autoEnrollActions.saveAutoEnrollRulesSuccess())
  } catch {
    yield put(autoEnrollActions.saveAutoEnrollRulesFailed())
  }
}

export function* watchGetAutoEnrollRules() {
  yield takeEvery(
    autoEnrollActions.getAutoEnrollRules.type,
    getAutoEnrollRulesSaga
  )
}

export function* watchSaveAutoEnrollRules() {
  yield takeEvery(
    autoEnrollActions.saveAutoEnrollRules.type,
    saveAutoEnrollRulesSaga
  )
}

export default function* autoEnrollSaga() {
  yield all([watchGetAutoEnrollRules(), watchSaveAutoEnrollRules()])
}
